import { BaseModel } from './BaseModel';

export class LearningUnitType extends BaseModel {
  static get entity() {
    return 'learning-unit-types';
  }

  static get fk() {
    return 'learning_unit_type_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      description: this.attr([]),
      created_by: this.attr(null),
      created_at: this.attr(null),
      updated_At: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static getDetailType(type) {
    const details = {
      General: [
        'There is only one Learning Outcome.',
        'No certificate provided.',
        'Learners can learn at their own pace through videos or any other forms designed by the instructor.',
        'Each Learning Unit can contain up to 4 teaching sessions. Each session should not exceed 6-week duration.',
        'Assessment activities could be provided in the Learning Unit, but they are not required. However, no certificate will be awarded.'
      ],

      OBEM: [
        'There is only one Learning Outcome.',
        'Certificate is provided.',
        'In order to assist the learner to achieve the Learning Outcome, interactive sessions such as virtual meetings, reviews, and feedback are provided.',
        'Each Learning Unit can contain up to 4 teaching sessions. Each session should not exceed 6-week duration.',
        'At least one assessment activity that is aligned with the Learning Outcome is required for the Learning Unit.',
        'The instructor is required to assess the learner individually in order to grant a Learning Outcome certificate.'
      ]
    };

    return details[type];
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/learning-unit-types`);
      }
    }
  };
}

export default LearningUnitType;
